// extracted by mini-css-extract-plugin
module.exports = {"panel":"_b046cce","panelHeader":"_c705327"};